import { useContext } from "react";
import { createNotify, Ctx, type MessageApi, type Notify } from "../feedback";
import { message } from "antd";

export function useAppMessage(): Notify {
    const api = useContext(Ctx);
    // Фоллбек на глобальный message, если провайдера нет (не рекомендуется, но работает)
    const inst = api ?? (message as unknown as MessageApi);
    return createNotify(inst);
}
